import React from 'react';
import FAQBase from './FAQBase';

const questions = [
  {
    question:
      'If someone named in my documents moves or changes their name after becoming married, do I need to update the information?',
    answer:
      "Minor changes, such as a new address or last name, do not always require document updates, but it's a good idea to review your plan periodically to make sure it still clearly identifies the intended person. You can come back to update your estate plan online as needed.",
  },
];

const ExecutorsFAQ = () => <FAQBase questions={questions} />;

export default ExecutorsFAQ;
